import {Component, HostListener} from "@angular/core";
import {FUIEventsService} from "../events/events.service";

@Component({
    selector: "fui-canvas",
    styleUrls: ["./canvas.component.scss"],
    templateUrl: "./canvas.component.html"
})
export class FUICanvasComponent {
    constructor(private eventsService: FUIEventsService) {
    }

    /**
     * Register click events on the canvas, and use like you would
     * usually a document click event.
     * @param {MouseEvent} mouseEvent
     */
    @HostListener("click", ["$event"])
    public click(mouseEvent: MouseEvent): void {
        mouseEvent.stopPropagation();
        this.eventsService.click = mouseEvent;
    }

    @HostListener("mousedown", ["$event"])
    public mousedown(mouseEvent: MouseEvent): void {
        mouseEvent.stopPropagation();
        this.eventsService.click = mouseEvent;
    }
}
